import React from "react";

const Button = ({
    type = "button",
    children,
    className = "",
    width = "",
    py = "",
    px = "",
    loading = false, // new prop
    disabled = false, // can still be passed manually
    ...props
}) => {
    const isDisabled = loading || disabled;

    return (
        <button
            type={type}
            disabled={isDisabled}
            className={`
                relative flex items-center justify-center
                bg-white font-urbanist text-black font-bold
                ${py || "py-3"} ${px || "px-12"} 
                rounded-lg transition-colors 
                ${width || "w-1/2"} ${className}
                ${isDisabled ? "opacity-70 cursor-not-allowed" : "hover:bg-gray-200"}
            `}
            {...props}
        >
            {/* Loader Spinner */}
            {loading && (
                <span
                    className="inline-block w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2"
                ></span>
            )}

            {/* Button Text */}
            <span className={`${loading ? "opacity-70" : "opacity-100"}`}>
                {children}
            </span>
        </button>
    );
};

export { Button };
